import { useState } from 'react'
import { useApp } from '@/app/AppContext'
import { can } from '@/auth/permissions'
import { Icon } from '@/components/Icon'
import { MeetingFormModal, TaskFormModal, type ActivityTarget } from './ActivityForms'

/**
 * «Задача…» и «Встреча…» на карточке записи (#110, #112).
 *
 * Быстрая задача одной строкой остаётся в композере; здесь — полные формы: срок, повтор,
 * напоминание у задачи, участники, конец и место у встречи. Право — `sales.activity:create`:
 * задача и встреча — это работа человека, а не правка записи, к которой они относятся.
 */
export function PlanActivityButtons({ target }: { target: ActivityTarget }) {
  const { t, user } = useApp()
  const [form, setForm] = useState<'task' | 'meeting' | null>(null)
  if (!can(user, 'sales.activity', 'create')) return null
  return (
    <div className="row" role="group" aria-label={t('cal.plan')}>
      <button type="button" className="btn btn-secondary btn-sm" onClick={() => setForm('task')}>
        <Icon name="work" size="sm" />
        {t('cal.plan.task')}
      </button>
      <button type="button" className="btn btn-secondary btn-sm" onClick={() => setForm('meeting')}>
        <Icon name="meet" size="sm" />
        {t('cal.plan.meeting')}
      </button>
      {form === 'task' && <TaskFormModal target={target} onClose={() => setForm(null)} />}
      {form === 'meeting' && <MeetingFormModal target={target} onClose={() => setForm(null)} />}
    </div>
  )
}
